
import {
  onBeforeMount,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
  onUnmounted,
  onActivated,
  onDeactivated,
  nextTick
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  queryTaskList,
  queryCardDetail,
  queryCardList,
  queryTaskInfo,
  reportPoped
} from '@/api/aio'
import skuPopMask from '@/components/skuPopMask/Index.vue'
import {
  nativeToast,
  nativeShowAioShare,
  getClientCommonMessage,
  changeActionBar,
  getStatusBarInfo,
  nativeGoBack
} from '@/utils/nativeFn'
import { registerFnHandler } from '@/utils/registerFnHandler'
import WrongPage from '../../components/WrongPage.vue'
import LoadingPage from '../../components/LoadingPage.vue'
import TaskList from '@/components/Aio/TaskList.vue'
import TaskProgress from '@/components/Aio/TaskProgress.vue'
import ActionBar from '../../components/ActionBar/index.vue'
import TaskGuidePop from '@/components/Aio/TaskGuidePop.vue'
import { compareVersion } from '@/utils/compareVersion'
import store from '@/store/index'
import lottie from 'lottie-web'
import { dealLottiePath } from '@/utils/prefixLottie'
import gesture_swipe_left_n_right from '/public/lottie/gesture_swipe_left_n_right/gesture_swipe_left_n_right.json'

export default {
  name: 'CardDetail',
  components: {
    skuPopMask,
    WrongPage,
    LoadingPage,
    TaskList,
    ActionBar,
    TaskProgress,
    TaskGuidePop
  },
  setup() {
    console.log('setup start', window.location.href)
    const $xesLog = inject('$xesLog') as any // 埋点
    const router = useRouter()
    /**
     * 页面的初始化参数 gc_ecdbd2c08892f cdd00300e43df309
     */
    let {
      skuId = 'gc_3fbda30d03cc6',
      skuName = '',
      unionid: skuUnionid,
      cardId = 'cdfa38946e72e761',
      cardType: queryCardType = 0,
      source_location = ''
    } = useRoute().query || {}
    store.commit('taskPaper/SET_DATA', ['cardDetailQuery', useRoute().query || {}])
    skuId = skuId || skuUnionid
    skuName = decodeURI((skuName as string) || '')
    const unionid = ref(cardId)
    const cardType = ref(Number(queryCardType))
    const gestureGuide = ref(false)
    /**
     * 异常提示
     */
    let interfaceSuccessNum = 0 // 接口成功的数量
    const pageLoading = ref(true) // 页面加载中标识
    const showWrongPage = ref(false) // 是否展示接口失败页面
    const boxOpacity = ref(0) // 卡牌部分的透明度
    const fadeIn = ref(false) // 卡片详情淡入
    let theDoingTaskObj = { pUuid: '', uuid: '', resourceType: 0 } // 去完成任务的父任务id 和任务id
    /**
     * 处理左右滑动加载其他卡片
     */
    const cardList = ref([] as Array<string>) // 当前sku下所有卡牌的unionid列表
    const currentCardIdIndex = ref(0)
    const startTime = ref(0)
    const startX = ref(0)
    const startY = ref(0)

    const maskVisible = ref(false)
    // 任务引导弹框
    let taskGuideInfo = reactive({ title: '', detail: '' })
    const taskGuideVisible = ref(false)
    const actionMap = {
      'type-1-0': '去观看',
      'type-1-1': '再次观看',
      'type-4-0': '去练习',
      'type-4-1': '再次练习',
      locked: '敬请期待'
    }
    let tmpUpgradeIndex = null
    let reportTaskId = ''
    let rewardContent = '' // 升级文案
    const pTaskList = ref([]) // 父任务相关信息
    const cardPopInfo = reactive({}) // 弹框需要的参数
    const popType = ref(2) // 弹框类型 1: 详情 2: 升级
    interface ITypeCardInfo {
      card_id: number
      card_imgs: Array<{ star_num: number; star_img_url: string }>
      card_name: string
      max_star: number
      unionid: string
      user_card_star: string
      card_introduce: string
      card_type: number
    }
    let cardInfo = reactive({} as ITypeCardInfo)
    const taskListLoading = ref(true)
    const taskList = ref([])
    const currentLevel = ref(0) // 当前星级
    const currentViewLevel = ref(-1)
    const activeTab = ref(0)
    const displayTabWrapFixed = ref('none')
    const refTabWrap = ref(null)
    const refTabWrapFixed = ref(null)
    const refCardDetailWrap = ref(null)
    const maxPublishedLevel = ref(0) // 开放任务的最大星级数
    const isFinished = (status) => [1].includes(status)
    const cardName = ref('')
    const reportDataMap = {
      page_name: 'knowledge_card_detail',
      sku_name: skuName || '',
      sku_unid: skuId || '',
      task_card_type: cardType.value === 1 ? '无星' : '3星'
    }
    let clickedVideoPlay = false // 是否点击了播放视频
    let statusBarHeight = ref(0) // 状态栏高度
    let actionBarHeight = ref(0) // 默认actionBar高度
    const actionBarInfo = reactive({}) // actionBar需要的参数
    const showActionBar = ref(false) // 是否开启 actionBar 默认false, 版本大于 1.7.0开启
    let versionName = ref('0')
    // @ts-ignore
    watch([currentViewLevel, cardInfo], ([val1, val2]) => {
      // @ts-ignore 
      if (!(val1 !== -1 && cardInfo?.card_name)) {
        return true
      }
      cardName.value = cardInfo.card_name
      // 知识卡片状态曝光
      $xesLog.track('knowledge_card_status_element_show', {
        ...reportDataMap,
        card_name: cardInfo?.card_name || '',
        star_status: `${cardInfo?.user_card_star}star`,
        task_card_type: cardInfo?.card_type === 1 ? '无星' : '3星'
      })
    })
    watch(currentLevel, (val) => {
      // 当前正在查看的星级
      currentViewLevel.value = val
      activeTab.value = val === maxPublishedLevel.value ? val - 1 : val
      if (cardInfo?.unionid) {
        Object.assign(cardInfo, { user_card_star: val })
      }
    })
    // 更新任务currentViewLevel、currentLevelFinishedTaskNum、currentLevelFinishTaskNum、pTaskList
    watch(taskList, (val) => {
      let _pTaskList = (pTaskList.value || []).map((item) => ({ ...item, finishedNum: 0 }))
      val?.forEach((item, index) => {
        if (item.finish_status) {
          if (cardType.value === 2) {
            let tmpItem = _pTaskList?.[item.difficulty - 1] || {}
            tmpItem.finishedNum = (tmpItem.finishedNum || 0) + 1
            tmpItem.finish_status = tmpItem.finishedNum >= tmpItem.progress_limit_count ? 1 : 0
          } else {
            if (!_pTaskList[0]) {
              return
            }
            if (item.publish_status === 3) {
              _pTaskList[0].publish_status = true
            }
            _pTaskList[0].finishedNum = (_pTaskList[0].finishedNum || 0) + 1
            if (_pTaskList[0].finishedNum >= _pTaskList?.[0]?.progress_limit_count) {
              _pTaskList[0].finish_status = 1
              currentLevel.value = 1
            } else {
              _pTaskList[0].finish_status = 0
              currentLevel.value = 0
            }
          }
        }
      })
      pTaskList.value = _pTaskList
      currentViewLevel.value = currentLevel.value
    })
    const changeOpacity = () => {
      let timer = setInterval(() => {
        boxOpacity.value = boxOpacity.value + 1 / (1300 / 10)
        if (boxOpacity.value >= 1) {
          boxOpacity.value = 1
          clearInterval(timer)
        }
      }, 10)
    }
    const eventTaskTabShow = (index) => {
      // 知识点任务曝光
      $xesLog.track('cardDetail_taskTab_show', {
        ...reportDataMap,
        card_name: cardInfo.card_name,
        tab_status_show: `${index + 1}星`
      })
    }
    // 进度文案
    const progressData = computed(() => {
      let progressText = ''
      const {
        progress_limit_count: progressLimitCount,
        finishedNum = 0,
        finish_status,
        difficulty
      } = pTaskList.value?.[activeTab.value] || {}
      const progressWidth =
        finishedNum >= progressLimitCount ? 100 : (finishedNum * 100) / progressLimitCount
      if (cardType.value === 2) {
        progressText = finish_status
          ? `恭喜你已完成${progressLimitCount}个${difficulty}星任务，获得${difficulty}星卡牌！`
          : !finishedNum
          ? `完成${progressLimitCount}个${difficulty}星任务，就可以升级${difficulty}星卡牌啦～`
          : `再完成${
              progressLimitCount - finishedNum
            }个${difficulty}星任务，就可以升级${difficulty}星卡牌啦～`
      } else {
        progressText = finish_status
          ? `恭喜你已完成任务，点亮卡牌！`
          : !finishedNum
          ? `完成${progressLimitCount}个任务，就可以点亮卡牌啦～`
          : `再完成${progressLimitCount - finishedNum}个任务，就可以点亮卡牌啦～`
      }
      return {
        isFinished: !!finish_status,
        progressText,
        progressWidth,
        currentLevelFinishTaskNum: progressLimitCount,
        currentLevelFinishedTaskNum: finishedNum
      }
    })
    // 注册视频播放结束事件
    const registerPlayEnd = () => {
      registerFnHandler('onPlayVideoEnd', (res) => {
        clickedVideoPlay = false
        // 查询任务是否完成 pUuid
        getTaskInfo()
        console.log('play end sucess callback')
        return {
          message: 'play end sucess'
        }
      })
    }
    registerPlayEnd()
    const getTaskInfo = () => {
      let { pUuid, uuid } = theDoingTaskObj
      console.log('调取了任务')
      if (!(pUuid && uuid)) {
        return
      }
      let params = { user_task_uuid: pUuid, sub_uuid: pUuid === uuid ? '' : uuid, is_recursive: 0 }
      queryTaskInfo(params)
        .then((res) => {
          if (res?.data?.code === 0) {
            //  debugger
            const {
              finish_status,
              is_noticed,
              sub_tasks,
              user_task_uuid,
              reward_content,
              popup_detail = {}
            } = res.data.data || {}
            const sub_task = sub_tasks?.[0] || {}
            const { card_detail = {} } = popup_detail || {}
            if (uuid) {
              //  debugger
              if (isFinished(finish_status) && !is_noticed) {
                if (
                  (card_detail.card_type === 2 &&
                    card_detail.user_card_star > currentLevel.value) ||
                  card_detail.card_type !== 2
                ) {
                  let {
                    title = '',
                    popup_button_jump_type = 0,
                    popup_button_jump_url = '',
                    popup_button_title = ''
                  } = popup_detail
                  // 已升级未弹框
                  showUpgrade(
                    {
                      cardImage: card_detail.star_img_url,
                      cardName: card_detail.card_name,
                      cardDesc: card_detail.card_introduce,
                      currentLevel: card_detail.card_type !== 2 ? 0 : card_detail.user_card_star,
                      cardType: card_detail.card_type,
                      rewardContent: title || reward_content,
                      btnJumpType: popup_button_jump_type,
                      btnJumpUrl: popup_button_jump_url,
                      btnJumpText: popup_button_title
                    },
                    user_task_uuid
                  )
                  // 更新当前任务节点
                  currentLevel.value = card_detail.card_type !== 2 ? 1 : card_detail.user_card_star
                  // 更新cardInfo
                  pTaskList.value = (pTaskList.value || []).map((item) => {
                    if (item?.uuid === user_task_uuid) {
                      item.finish_status = finish_status
                    }
                    return item
                  })
                }
                let cardUnionids = JSON.parse(sessionStorage.getItem('cardUnionids') || '[]')
                !cardUnionids.includes(cardInfo.unionid) && cardUnionids.push(cardInfo.unionid)
                sessionStorage.setItem('cardUnionids', JSON.stringify(cardUnionids))
              } else {
                const { finish_status, is_noticed, popup_detail = {} } = sub_task
                // 有子任务 父任务未完成 子任务完成了
                if (pUuid !== uuid && isFinished(finish_status) && !is_noticed) {
                  if (popup_detail?.title) {
                    // 引导弹框
                    Object.assign(taskGuideInfo, popup_detail || {})
                    taskGuideVisible.value = true
                    // 上报已弹框
                    reportPoped({ user_task_uuid: uuid })
                  }
                }
              }
              // 如果当前任务完成 更新taskList
              if (
                (pUuid !== uuid && isFinished(sub_task?.finish_status)) ||
                (pUuid === uuid && isFinished(finish_status))
              ) {
                // 不需要提示且任务本身是已完成
                let tmpIndex = taskList.value.findIndex((item) => item.uuid === uuid)
                if (tmpIndex || tmpIndex === 0) {
                  let tmpItem = taskList.value[tmpIndex]
                  let tmpList = (taskList.value || []).map((item) => ({ ...item }))
                  if (!tmpItem.finish_status) {
                    tmpList.splice(tmpIndex, 1, {
                      ...tmpItem,
                      finish_status: 1,
                      btnText: actionMap[`type-${tmpItem.resource_type}-1`]
                    })
                    taskList.value = tmpList
                  }
                }
              }
            }
          }
          setTheDoingTaskObj({ pUuid: '', uuid: '', resourceType: 0 }, 'reset')
        })
        .catch((err) => {
          setTheDoingTaskObj({ pUuid: '', uuid: '', resourceType: 0 }, 'reset')
        })
    }
    // maidian
    // const maidian = ()=>{
    //     taskGuideVisible.value = true
    // }
    // 获取任务列表
    const queryTask = (showLoading = true) => {
      if (!unionid.value) {
        nativeToast('缺少卡牌信息')
        return
      }
      queryTaskList({ carrier_id: unionid.value as string, carrier_type: 1 })
        .then((res) => {
          taskListLoading.value = false
          const {
            code,
            message,
            data: { list }
          } = res.data
          // console.log(res.data,'res.data')
          let _pTaskList = []
          if (code === 0) {
            const tmpTaskList = []
            tmpUpgradeIndex = null
            interfaceSuccessNum++
            if (list.length) {
              list?.forEach((item, index) => {
                // 如果是星级卡牌
                let {
                  progress_limit_count = 0,
                  reward_content = '',
                  popup_button_jump_type = 1,
                  popup_button_jump_url = '',
                  popup_button_title = '',
                  action,
                  difficulty,
                  user_task = {},
                  extend = {}
                } = item || {}
                if (cardType.value === 1 && list.length === 1 && item.node_type === 0) {
                  currentLevel.value = 0
                  let { uuid, status, progress } = user_task
                  index === 0 &&
                    _pTaskList.push({
                      progress_limit_count,
                      reward_content,
                      popup_button_jump_type,
                      popup_button_jump_url,
                      popup_button_title,
                      uuid,
                      difficulty,
                      status,
                      progress,
                      action
                    })
                  if (item.publish_status === 3) {
                    _pTaskList[0].publish_status = true
                  }
                } else {
                  let { uuid, status, progress } = user_task
                  _pTaskList.push({
                    uuid,
                    difficulty,
                    progress,
                    action,
                    progress_limit_count,
                    reward_content,
                    popup_button_jump_type,
                    popup_button_jump_url,
                    popup_button_title,
                    finish_status: item?.user_task?.finish_status,
                    publish_status: item.publish_status === 3,
                    labels: item?.labels || [],
                    status: item?.user_task?.status,
                    max_upload_num: extend?.max_upload_num || 6,
                    column_id: skuId,
                    card_id: unionid.value
                  })
                }
                if (
                  (index === 0 || isFinished(item?.user_task?.finish_status)) &&
                  item.publish_status === 3
                ) {
                  currentLevel.value = isFinished(item?.user_task?.finish_status)
                    ? index + 1
                    : index
                }
                // 确定下是不是要加publish_status的判断
                if (
                  isFinished(item?.user_task?.finish_status) &&
                  !item?.user_task?.is_noticed &&
                  currentLevel.value === index + 1
                ) {
                  tmpUpgradeIndex = index
                  reportTaskId = item?.user_task?.uuid
                }
                let hasActiveTask = false
                if (item.node_type === 1 && action !== 5) {
                  // 有子任务并且不是图片上传
                  item?.sub_task?.length &&
                    item.sub_task?.forEach((tile, i) => {
                      const {
                        title,
                        resource,
                        resource_type,
                        type,
                        difficulty,
                        publish_status: sub_publish_status,
                        user_task
                      } = tile
                      const finish_status = isFinished(user_task?.finish_status) ? 1 : 0
                      const uuid = user_task?.uuid
                      const publish_status = item.publish_status === 3 && sub_publish_status === 3
                      let btnText = ''
                      let btnEnable = false
                      if (
                        (!publish_status &&
                          (item.publish_status === 4 || sub_publish_status === 4)) ||
                        !actionMap[`type-${resource_type}-${finish_status}`]
                      ) {
                        btnText = actionMap.locked
                        btnEnable = false
                      }
                      if (publish_status && actionMap[`type-${resource_type}-${finish_status}`]) {
                        hasActiveTask = true
                        btnText = actionMap[`type-${resource_type}-${finish_status}`]
                        if (
                          resource_type === 4 &&
                          !finish_status &&
                          (user_task?.status || 0) >= 2
                        ) {
                          btnText = actionMap[`type-${resource_type}-1`]
                        }
                        btnEnable = true
                      }
                      tmpTaskList.push({
                        uuid,
                        title,
                        resource,
                        resource_type,
                        type,
                        difficulty,
                        publish_status,
                        btnText,
                        btnEnable,
                        progress_limit_count: item.progress_limit_count,
                        finish_status,
                        pUuid: item?.user_task?.uuid,
                        status: user_task?.status
                      })
                    })
                } else {
                  // console.log(item,'item')
                  // 无子任务或者是图片上传（图片上传只处理父任务）
                  const {
                    title,
                    resource,
                    resource_type,
                    type,
                    difficulty,
                    publish_status,
                    progress_limit_count,
                    user_task = {}
                  } = item
                  const uuid = user_task?.uuid
                  const finish_status = isFinished(user_task?.finish_status) ? 1 : 0
                  let btnText = ''
                  let btnEnable = false
                  if (
                    publish_status === 4 ||
                    !actionMap[`type-${resource_type}-${finish_status}`]
                  ) {
                    btnText = actionMap.locked
                    btnEnable = false
                  } else if (publish_status === 3) {
                    hasActiveTask = true
                    btnText = actionMap[`type-${resource_type}-${finish_status}`]
                    btnEnable = true
                  }
                  store.commit('star3Note/SET_MAX_NUM', [
                    'max_upload_num',
                    { [item.carrier_id]: item.extend.max_upload_num }
                  ])
                  tmpTaskList.push({
                    uuid,
                    title,
                    resource,
                    resource_type,
                    type,
                    difficulty,
                    publish_status: publish_status === 3,
                    btnText,
                    btnEnable,
                    progress_limit_count,
                    finish_status,
                    pUuid: uuid,
                    status: user_task?.status
                  })
                }
                if (
                  item.publish_status === 3 &&
                  (item.node_type === 0 || (item.node_type === 1 && hasActiveTask) || action === 5)
                ) {
                  // debugger
                  maxPublishedLevel.value = cardType.value === 2 ? item.difficulty : 1
                }
              })
              taskList.value = tmpTaskList
              // maxUnNoticedLevel.value =_maxUnNoticedLevel
            } else {
              taskList.value = []
            }
            ;((showLoading && interfaceSuccessNum === 2) || !showLoading) &&
              dealLoadingAndWrong({ loading: false, wrong: false })
            if (currentLevel.value === 0 || cardType.value === 1) {
              eventTaskTabShow(0)
            }
          }
          pTaskList.value = _pTaskList
        })
        .catch((err) => {
          pTaskList.value = []
          taskList.value = []
          dealLoadingAndWrong({ loading: false, wrong: true })
        })
    }
    const queryCardInfo = () => {
      queryCardDetail({ unionid: unionid.value as string })
        .then((res) => {
          if (res.data.code === 0 && res?.data?.data?.unionid) {
            interfaceSuccessNum++
            // fadeIn.value = false
            if (res?.data?.data) {
              if (fadeIn.value) {
                const timer = setTimeout(() => {
                  fadeIn.value = false
                  clearTimeout(timer)
                  const timerInner = setTimeout(() => {
                    fadeIn.value = true
                    clearTimeout(timerInner)
                  }, 500)
                }, 100)
              } else {
                const timer = setTimeout(() => {
                  fadeIn.value = true
                  clearTimeout(timer)
                }, 500)
              }
            }
            Object.assign(cardInfo, res?.data?.data || {})
            cardType.value = (cardInfo?.card_type || 0) as number
            handlePageScroll()
            // 注册分享方法 供actionbar使用 只有1.8.0之前的版本会用
            registerFnHandler('shareInAio', (res) => {
              return {
                unionid: unionid.value,
                channelName: 'share_common',
                ...reportDataMap,
                card_name: cardInfo?.card_name || ''
              }
            })
            document.title = cardInfo?.card_name
            interfaceSuccessNum === 2 && dealLoadingAndWrong({ loading: false, wrong: false })
            if (compareVersion(versionName.value, '1.8.0') != -1) {
              // 初始化弹窗
              initActionBar()
              // 获取状态栏高度 + 计算actionBar高度
              getStatusBarHeight()
            }
          } else {
            cardInfo = { card_imgs: [] } as ITypeCardInfo
            dealLoadingAndWrong({ loading: false, wrong: true })
          }
        })
        .catch((err) => {
          cardInfo = { card_imgs: [] } as ITypeCardInfo
          // process.env.NODE_ENV !== 'development' && dealLoadingAndWrong({loading: false, wrong: err?.message?.includes("timeout") || false})
        })
    }
    const getCardList = () => {
      queryCardList({ column_unionid: skuId as string }).then((res) => {
        const { card_list } = res?.data?.data || {}
        // FIX js error - (card_list || [])
        cardList.value = (card_list || []).map((item, index) => {
          if (item.unionid === unionid.value) {
            currentCardIdIndex.value = index
          }
          return item.unionid
        })
      })
    }
    const doClose = () => {
      maskVisible.value = false
    }
    const doShare = () => {
      let channelName = popType.value === 1 ? 'pop_up_card_activate' : 'pop_up_1star'
      // 调用客户端分享方法
      nativeShowAioShare({
        ...reportDataMap,
        unionid: unionid.value,
        channelName,
        card_name: cardInfo?.card_name || ''
      })
      doClose()
    }
    const doCloseGuide = () => {
      taskGuideVisible.value = false
      Object.assign(taskGuideInfo, { title: '', detail: '' })
    }
    let queryDone = false
    const initDataQuery = () => {
      if (queryDone) {
        return
      }
      // 变更actionbar颜色
      changeActionBar({ bgColor: '#ffffff', mode: 'light' }, (res) => {
        console.log('h5调用端上changeActionBar', res) // app返回给前端的值
      })
      getClientCommonMessage({}, (res) => {
        res.token && localStorage.setItem('tal_token', res.token)
        res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
        res.services_version = localStorage.setItem('service_version', res.service_version)
        queryDone = true
        clickRefresh()
        versionName.value = res.service_version_name
        if (compareVersion(versionName.value, '1.8.0') != -1) {
          // 初始化弹窗
          initActionBar()
          // 获取状态栏高度 + 计算actionBar高度
          getStatusBarHeight()
        }
      })
    }
    // 初始化弹窗
    const initActionBar = () => {
      showActionBar.value = true
      Object.assign(actionBarInfo, {
        actionBarTitle: cardInfo?.card_name,
        actionBarBg: 'transparent'
      })
    }
    onBeforeMount(() => {
      // console.log('onBeforeMount', unionid, skuId)
      initDataQuery()
      let num = 0
      let timer = setInterval(() => {
        if (queryDone) {
          clearInterval(timer)
          return
        } else {
          initDataQuery()
          num++
          if (num === 10) {
            clearInterval(timer)
            clickRefresh()
          }
        }
      }, 500)
    })
    onMounted(() => {
      console.log('mounted')
      renderLottie()
    })
    onUnmounted(() => {
      window.removeEventListener('scroll', handleTitleChange, true)
      refCardDetailWrap.value?.removeEventListener('touchstart', handelTouchStart, true)
      refCardDetailWrap.value?.removeEventListener('touchend', handelTouchend, true)
    })
    const initData = (cardId = unionid.value) => {
      refCardDetailWrap.value?.removeEventListener('touchstart', handelTouchStart, true)
      refCardDetailWrap.value?.removeEventListener('touchend', handelTouchend, true)
      unionid.value = cardId
      activeTab.value = 0
      interfaceSuccessNum = 0
      boxOpacity.value = 0.2
      queryTask()
      queryCardInfo()
    }
    const clickRefresh = () => {
      getCardList()
      initData()
    }
    // 处理loading
    const dealLoadingAndWrong = ({ loading, wrong }) => {
      pageLoading.value = loading
      showWrongPage.value = wrong
      if (!loading && !wrong && cardInfo?.unionid) {
        changeOpacity()
        let { user_id = '' } = JSON.parse(localStorage.getItem('clientCommonMessage') || '{}')
        if (localStorage.getItem(`left_right_gesture_guide-${user_id || ''}`) !== '1') {
          gestureGuide.value = true
          let timer = setTimeout(() => {
            localStorage.setItem(`left_right_gesture_guide-${user_id || ''}`, '1')
            gestureGuide.value = false
            clearTimeout(timer)
          }, 4000)
        } else {
          gestureGuide.value = false
        }

        $xesLog.view(
          'page_view',
          {
            ...reportDataMap,
            source_location,
            page_name: 'knowledge_card_detail',
            task_card_type: cardType.value === 1 ? '无星' : '3星',
            card_status_with_task: maxPublishedLevel.value,
            task_detail_show: `${currentLevel.value}星`
          },
          () => {
            console.log('埋点成功')
          }
        )
      }
      if (taskList.value.length === 0 && !loading && !wrong && cardInfo?.unionid) {
        currentLevel.value = Number(cardInfo.user_card_star || 0)
        currentViewLevel.value = currentLevel.value
      }
      nextTick(() => {
        // 未弹框的等级大于等于当前星级采取弹框
        if (
          tmpUpgradeIndex !== null &&
          tmpUpgradeIndex + 1 >= currentLevel.value &&
          !loading &&
          !wrong &&
          cardInfo?.card_imgs
        ) {
          let {
            reward_content = '',
            popup_button_jump_type = 0,
            popup_button_jump_url = '',
            popup_button_title = ''
          } = pTaskList.value?.[currentLevel.value - 1] || {}
          showUpgrade(
            {
              cardType: cardType.value,
              cardImage: cardInfo?.card_imgs?.[currentLevel.value].star_img_url,
              cardName: cardInfo.card_name,
              cardDesc: cardInfo.card_introduce,
              currentLevel: currentLevel.value,
              rewardContent: reward_content,
              btnJumpType: popup_button_jump_type,
              btnJumpUrl: popup_button_jump_url,
              btnJumpText: popup_button_title
            },
            reportTaskId
          )
        } else {
          let { pUuid, uuid, resourceType } = store.getters['taskPaper/theDoingTaskObj'] || {}
          // 如果是答题 页面跳转后补中间过程弹框
          if (!loading && !wrong && resourceType === 4 && pUuid && uuid) {
            theDoingTaskObj = { pUuid, uuid, resourceType }
            getTaskInfo()
          }
        }
      })
      let _knowledge_points_name = []
      let _knowledge_task_name = []
      let _task_finish_status = []
      taskList.value?.forEach((item) => {
        _knowledge_points_name.push(item.title)
        _knowledge_task_name.push(
          item.resource_type === 1
            ? 'activate_watch_video'
            : item.resource_type === 4
            ? 'master_test'
            : 'use_magic_task'
        )
        _task_finish_status.push(item.finish_status ? '1' : '2')
      })
      // console.log(cardType.value,'knowledge_card_task_element_show')
      // 知识点任务曝光
      $xesLog.track('knowledge_card_task_element_show', {
        ...reportDataMap,
        card_name: cardInfo.card_name,
        knowledge_points_name: JSON.stringify(_knowledge_points_name),
        knowledge_task_name: JSON.stringify(_knowledge_task_name),
        task_finish_status: JSON.stringify(_task_finish_status),
        task_card_type: cardType.value === 1 ? '无星' : '3星'
      })
      nextTick(() => {
        handleTitleChange()
        refCardDetailWrap.value.addEventListener('touchstart', handelTouchStart, true)
        refCardDetailWrap.value.addEventListener('touchend', handelTouchend, true)
      })
    }
    // 切换查看的卡牌
    const updateCurrentViewLevel = (index) => {
      // console.log(cardInfo?.card_type,'cardInfo?.card_type')
      currentViewLevel.value = index
      nextTick(() => {
        handleTitleChange()
      })
      // 知识点任务卡状态切换点击
      $xesLog.track('button_click', {
        ...reportDataMap,
        card_name: cardInfo?.card_name || '',
        button_name: 'knowledge_card_shift_button',
        button_status: currentViewLevel.value || 0,
        task_card_type: cardInfo?.card_type === 1 ? '无星' : '3星'
      })
    }
    // 点击图片弹出知识点详情
    const showCardInfo = () => {
      if (currentViewLevel.value > currentLevel.value) {
        nativeToast('完成任务才能获得卡牌哦')
        return
      } else {
        maskVisible.value = true
        Object.assign(cardPopInfo, {
          cardImage: cardInfo?.card_imgs?.[currentViewLevel.value || 0].star_img_url,
          cardName: cardInfo.card_name,
          cardDesc: cardInfo.card_introduce,
          currentLevel: currentViewLevel.value,
          skuName,
          skuId
        })
        popType.value = 1
        // 知识卡片状态曝光
        $xesLog.track('knowledge_card_status_element_show', {
          ...reportDataMap,
          card_name: cardInfo?.card_name || '',
          star_status: `${currentViewLevel.value}star`,
          task_card_type: cardInfo?.card_type === 1 ? '无星' : '3星'
        })
      }
    }
    // 点击图片弹出知识点详情
    const showUpgrade = (detail, user_task_uuid) => {
      Object.assign(cardPopInfo, detail, { skuName })
      popType.value = 2
      maskVisible.value = true
      // 上报已弹框
      reportPoped({ user_task_uuid: user_task_uuid })
    }
    const handelTouchStart = (e) => {
      startTime.value = Date.now()
      startX.value = e.changedTouches[0].clientX
      startY.value = e.changedTouches[0].clientY
    }
    const handelTouchend = (e) => {
      let endTime = Date.now()
      let endX = e.changedTouches[0].clientX
      let endY = e.changedTouches[0].clientY
      if (endTime - startTime.value > 3000) {
        //正常操作不会大于2秒
        return
      }
      //如果Y轴移动大于40,证明是上下滑动,所以不做处理
      if (Math.abs(endX - startX.value) > 10 && Math.abs(endY - startY.value) < 40) {
        let direction = endX - startX.value > 0 ? 'right' : 'left'

        if (direction === 'right') {
          if (currentCardIdIndex.value === 0) {
            nativeToast('已经是第一张了')
            return
          }
          initData(cardList.value[currentCardIdIndex.value - 1])
          currentCardIdIndex.value = currentCardIdIndex.value - 1
        } else {
          if (currentCardIdIndex.value === cardList.value.length - 1) {
            nativeToast('已经是最后一张了')
            return
          }
          initData(cardList.value[currentCardIdIndex.value + 1])
          currentCardIdIndex.value = currentCardIdIndex.value + 1
        }
      } else {
        return
      }
    }
    // 左侧返回
    const goBack = () => {
      console.log('调用端返回')
      nativeGoBack({}, () => {
        console.log('返回sku详情成功')
      })
    }

    // 获取状态栏高度
    const getStatusBarHeight = () => {
      getStatusBarInfo({}, (res) => {
        // console.log("h5调用端上getStatusBarInfo", res); // app返回给前端的值
        statusBarHeight.value = res.height
        actionBarHeight.value = 44 + res.height
      })
    }
    /**
     * 处理页面滚动
     */
    const handlePageScroll = () => {
      window.addEventListener('scroll', handleTitleChange, true)
    }
    /**
     * 页面标题change
     */
    let handleTitleChange = () => {
      // const scrollT = document.body.scrollTop || document.documentElement.scrollTop;
      // console.log(refCardDetailWrap.value.getBoundingClientRect().top, 'scrollTop')
      const bgMap = {
        '0': 'linear-gradient(180deg,#ffffff, #f8f6f1 78%)',
        '1': 'linear-gradient(180deg,#ffffff, #fef1e8 78%)',
        '2': 'linear-gradient(180deg,#ffffff, #ebf0f8 78%)',
        '3': 'linear-gradient(180deg,#ffffff, #fef8e8 78%)'
      }
      if (refCardDetailWrap.value && refCardDetailWrap.value.getBoundingClientRect().top < 0) {
        Object.assign(actionBarInfo, {
          actionBarTitle: cardInfo?.card_name,
          actionBarBg: bgMap[currentViewLevel.value]
        })
      } else {
        Object.assign(actionBarInfo, {
          actionBarTitle: cardInfo?.card_name,
          actionBarBg: 'transparent'
        })
      }
      if (
        refTabWrap.value?.getBoundingClientRect().width &&
        refTabWrap.value?.getBoundingClientRect().top - actionBarHeight.value <= 0
      ) {
        displayTabWrapFixed.value = 'block'
      } else {
        displayTabWrapFixed.value = 'none'
      }
    }
    const setTheDoingTaskObj = (obj, type = '') => {
      if (obj?.uuid || type === 'reset') {
        theDoingTaskObj = obj
        store.commit('taskPaper/SET_DATA', ['theDoingTaskObj', theDoingTaskObj])
      }
    }
    const tabClick = (index) => {
      activeTab.value = index
      eventTaskTabShow(index)
    }
    watch(activeTab, (val) => {
      val > -1 && eventTaskTabShow(val)
    })
    const renderLottie = () => {
      let lottie_json = gesture_swipe_left_n_right
      const lottiePath = 'images/'
      const newLottiePath = dealLottiePath(lottiePath)
      lottie_json?.assets?.forEach((item) => {
        item.u = newLottiePath
      })
      lottie.loadAnimation({
        container: document.getElementById('guide-box'), // 元素动画容器
        renderer: 'svg',
        loop: true,
        animationData: lottie_json // the path to the animation json
      })
    }
    return {
      skuId,
      unionid,
      reportDataMap,
      taskListLoading,
      taskList,
      actionMap,
      currentLevel,
      currentViewLevel,
      activeTab,
      refTabWrap,
      refCardDetailWrap,
      refTabWrapFixed,
      displayTabWrapFixed,
      maxPublishedLevel,
      cardInfo,
      cardName,
      updateCurrentViewLevel,
      popType,
      cardPopInfo,
      maskVisible,
      showCardInfo,
      doClose,
      doShare,
      // onClickBtn,
      // onClickTaskTile,
      showWrongPage,
      pageLoading,
      handelTouchStart,
      handelTouchend,
      currentCardIdIndex,
      cardList,
      clickRefresh,
      fadeIn,
      goBack,
      statusBarHeight,
      actionBarHeight,
      actionBarInfo,
      getStatusBarHeight,
      showActionBar,
      progressData,
      taskGuideInfo,
      taskGuideVisible,
      doCloseGuide,
      pTaskList,
      cardType,
      setTheDoingTaskObj,
      tabClick,
      boxOpacity,
      gestureGuide,
      versionName
    }
  }
}
